import { render } from "./SoftBenefits.vue?vue&type=template&id=0ade6e80"
import script from "./SoftBenefits.vue?vue&type=script&lang=js"
export * from "./SoftBenefits.vue?vue&type=script&lang=js"

import "./SoftBenefits.vue?vue&type=style&index=0&id=0ade6e80&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__